module.exports = __webpack_public_path__ + "img/WhatsApp-icon.fdb75b14.png";